module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/gift-96ed9d944718be3b3dfe723fac6b3b2f.svg";